module.exports = __webpack_public_path__ + "img/2024-10-16f_1.0ce8310e.jpg";